var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoNpr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-logo_npr") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-logo_npr"
  }, /*#__PURE__*/React.createElement("image", {
    id: "07_p_npr",
    x: 0,
    y: 16,
    width: 48,
    height: 16.3298969,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAAhCAYAAADJXsXPAAAAAXNSR0IArs4c6QAAA6hJREFUaAXtmktoFEEQhpMoIYpofD8vQQURjAeJiCgED+JNPXgQFURPXsSDgjcXT+Ip6E3MQREFMbD4QDDgKyp6MauiCKIJBC/iIz4SY4yPr5Zp0umdncnM9M7OhCn4U1093fV3V0339Ey29h9Sk0mcEdgO2XVwAEwD3ZP5U1OLiI5TyH0bfP1Q52LmbYSvF17RsQpzzjuEW9BfwQzQVOdUZireCLyHbg54AOqLKyFe/oyNVdjNqphOJGaDq1kSqnRPkIh7ijrbjlQkqqizJFQx+Io6S4KKRBW17zOBB8gmxnfQGeMFtByz9oGdYCWYCj6CR+A0e91jtBWB+wyO5jnOetBXwFGwDjSAT+A5uAnOwz2AtibG3MXvKSAch8F6IA/Xz6AA9sMvcQguEHm+rHF5r7Rx5A36oTLK6GPjGQV920DOqy3XezWOQcp/NNss9lHR4uVPrtGmEfT7tXPa6nMXvjvAbQwF6n3ftWiTB9tM7qDb0TIcyB3gJTmIZJXYlik49BrvEq53wr3UNrHmr5Wy2xhOsAo8b2bNR0nRzWFJI5eKJ9TtAmuAZLYL6HJcNyyW5XV/K2gFkuhzYAQokTfQk8qokP6O30NgLdgBzoLLILxw53hmkMvmkmynbkzysOvBa6DLCq9R0TDodvSKPiVLnrrNQN8iRrAXlOPmWpTtSHxvLOfbr56+VrYj4bnG0vurE2IPY1/S6ygvN+yo5rDbkqfuFo7zmvNJlEMHSvPjVuyAz1z1bu0C1Y25owP1LG3cY1TNMuxKmp2G82bDtmXeteVI92MzCd90x5RLtg7juk2zz3A207BtmT9tOdL92EyC7jfu8i+DUE5SqZGJkoT5RsTlBSo1MlGSIMdFXd7pRtLLqU8Cxz5ZBXuMQN837ESbaUrCIgK+WkWTch1oxb4N9AdxF8fIl6pdGrTvB7wETWIuYykQeDkKD4HFQD6g6fIb44hekYZympKg4tmkCoaWxOxmFcgnlVRJmrajH0T2i0t05ewu35CaSUCHy/XEV41nJVxkFvpngYEys7pBvb43D5ZpF7b6LR1bwCqw0HHyAf2M4Mtnk0qIOXfbcyqO2TcJzgR9J0k72Y/7KxEJ5dPheKrsSuvxzj3qONK0HUWda2L7Z0lIQGqyJGRJSEAEEjAE3wdzlce4AX41Rt/DQZXHGpq+OEHeQnOhPYTvKD9bGQrCTdvwbKM95acyDUF4R7tGLrn+y7eWwbRFdp05CBKBdo6+L/QO/wEKn9I99WSovgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeDasharray: "2,3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L46,46",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L46,46",
    id: "Line-Copy",
    transform: "translate(24.000000, 24.000000) scale(-1, 1) translate(-24.000000, -24.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoNpr);
export default __webpack_public_path__ + "static/media/icon-logo_npr.759df8ea57ab57c5520095a8e9179224.svg";
export { ForwardRef as ReactComponent };